import { sanitizeIdentifier } from '@angular/compiler';
import { Component, OnInit, AfterContentChecked, ChangeDetectorRef, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PageService } from '../services/page.service';
import { ClienteComponent } from '../../components/cliente/cliente.component';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {AsyncPipe} from '@angular/common';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';

import { DatePipe } from '@angular/common';



@Component({
  selector: 'app-ayudas',
  templateUrl: './ayudas.component.html',
  styleUrls: ['./ayudas.component.css'],
})

export class AyudasComponent implements OnInit, AfterContentChecked {
  marcaModelo = new FormControl('');
  autonomiaKm=new FormControl('');
  potenciaKwh=new FormControl('');

  options: string[] = [];
  
  filteredOptions: Observable<string[]>;
  tipoAyudaSigla: string;
  tipoAyuda: string;

  @ViewChild('clienteComponent', { static: false }) cliente: ClienteComponent;
  datosVehiculos: FormGroup;
  datosAyuda: FormGroup;
  documentos: FormGroup;
  isEditable = true;
  datoTramite: any;
  exencion: boolean;
  solicitud: string;
  observacion: any;
  provincias: any[];
  ocultar = true;
  clienteComprador: any;
  archivos: any[] = [];
  clasif: any;
  spinnerFirma: any;
  spinnerEITV = false;
  recuperadoEITV = true;
  mostrarCif = false;
  mostrarIAE = false;
  mostrarMinimis = false;
  achatarra = false;
  hoy = new Date();
  option: any;
  reduccionEmisiones: string;
  ahorroEnergetico: string;
  tipoInstalacion: string;
  numeroConectores: string;
  tipoConector: string;
  marcaModeloCargador: string;
  inversionTotal: string;
  esReinicia=false;
  faltaMarcaModelo=false;
  esMoves=false;
  expedienteConsorcio: string;
  requeridosOK = true;
  concesion: string;
/*
  token: string;
  url: any;
  concesion: string;*/

  constructor(private sanitizer: DomSanitizer, private cdRef: ChangeDetectorRef,
    private fb: FormBuilder,
    private servicio: PageService,
    private router: Router,
    private date: DatePipe) {
    //this.sanitizer=sanitizer;
    
  } 

  ngOnInit(): void {
    this.inicio();
    this.tipoAyuda=sessionStorage.getItem('tipo');
    this.concesion=sessionStorage.getItem('colaborador');
    if(this.tipoAyuda=="AYUDA REINICIA")
    {
      console.log("ES REINICIA");
      this.esReinicia=true;
      this.datosAyuda.controls.tipoAyuda.setValue("PLAN REINICIA AUTO");
    }
    if(this.tipoAyuda=="AYUDA MOVES")
      {
        console.log("ES MOVES");
        this.esMoves=true;
      }
    /*this.filteredOptions = this.marcaModelo.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '')),
    );*/
  }

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();

  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }

  

/*
  transformURL(){
    this.token=sessionStorage.getItem('token');
    this.concesion=sessionStorage.getItem('colaborador');
    this.url="https://share.hsforms.com/1aZJ8K8S9R7aFghWOyY9FTg4j2os?utm_id=";
    this.url=this.url+this.token+"&concesion="+this.concesion;
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.url); 
  }*/

    get datosCliente(): any {
      return this.cliente ? this.cliente.cliente$ : null;
    }
  
    get bastidorNoValido(): any {
      return (
        this.datosVehiculos.get('bastidor').invalid &&
        this.datosVehiculos.get('bastidor').touched
      );
    }
  
    get marcaNoValido(): any {
      return (
        this.datosVehiculos.get('marca').invalid &&
        this.datosVehiculos.get('marca').touched
      );
    }

    get baseNoValido(): any {
      return (
        this.datosVehiculos.get('baseImponible').invalid &&
        this.datosVehiculos.get('baseImponible').touched
      );
    }
  
    get modeloNoValido(): any {
      return (
        this.datosVehiculos.get('modelo').invalid &&
        this.datosVehiculos.get('modelo').touched
      );
    }
  
    inicio(): void {
      this.solicitud = sessionStorage.getItem('id');
      sessionStorage.setItem('tipoCliente', '1');
      //sessionStorage.setItem('tipo', 'AYUDA MOVES');
      this.clasificaciones();
      this.getProvincia();
      if (sessionStorage.getItem('colaborador') === 'null') {
        this.router.navigate(['page/home']);
      }
      this.crearFormulario();
      if (this.solicitud !== 'null') {
        //console.log('aca');
        this.getSolicitud();
      }
    }
  
    crearFormulario(): any {

        this.datosVehiculos = this.fb.group({
          matricula: '',
          tipo: '',
          colaborador: '',
          usuarioweb: '',
          tipoVehiculo: '10',
          //servicioalquesedestina: 'B00 - PART-SIN ESPECIFICAR',
          //exencion: '0',
          //tipoexencion: 'NS2',
          //renting: '0',
          //solicitardistintivo: '0',
          bastidor: '',
          marca: '',
          modelo: '',
          //tipoImpositivo: '0',
          baseImponible: '0.00',
          cv: '',
          co2: ['0', [Validators.minLength(1)]],
          //impuestoMatriculacion: '',
          //importeTotalFactura: ['0', [Validators.required, Validators.min(1)]],
          fechaMatriculacion: [null],
          cilindrada: '',
          potenciaFiscal: '',
        });

        this.datosAyuda = this.fb.group({
          tipoSolicitante: 'PARTICULAR ESPAÑOL',
          tipoAdquisicion: 'DIRECTA',
          tipoAyuda: ['', [Validators.required]],
          demo: '0',
          vehiculoNuevo: ['0', [Validators.required]],
          cif: '',
          IAE: '',
          minimis: '',
          achatarra: '0',
          facturar: 'CONCESION',
          marcaElectrico: '',
          autonomiaKm: '',
          potenciaKwh: '',
          IBAN: '',
          fechaAchatarrado: '',
          matriculaAchatarrado: '',
          marcaAchatarrado: '',
          modeloAchatarrado: '',
          adicional: 'NO',
          fechaInicioProyecto: '',
          fechaFinalProyecto: '',
          reduccionEmisiones: '',
          ahorroEnergetico: '',
          tipoInstalacion: '',
          numeroConectores: '',
          tipoConector: '',
          marcaModeloCargador: '',
          inversionTotal: '',
          expedienteConsorcio: ''
        });
      
    }
  
    getVehiculo(): void {
      if (this.datosVehiculos.value.matricula.length > 5) {
        this.servicio
          .getOneVehiculo(this.datosVehiculos.value.matricula)
          .subscribe(
            (res) => {
              console.log(res);
              if (res.matricula === this.datosVehiculos.value.matricula) {
                if (res.vehiculo != null) {
                  this.setDatos(res.vehiculo);
                } else {
                  this.datosVehiculos.setValue({
                    tipo: '',
                    colaborador: '',
                    matricula: this.datosVehiculos.value.matricula
                      ?.toUpperCase()
                      .trim(),
                    usuarioweb: '',
                    bastidor: '',
                    tipoVehiculo: '10',
                    marca: '',
                    modelo: '',
                    //servicioalquesedestina: 'B00 - PART-SIN ESPECIFICAR',
                    //exencion: '0',
                    //tipoexencion: 'NS2',
                    //cargas: '',
                    baseImponible: null,
                    //nroVentas: '',
                    fechaMatriculacion: null,
                    cilindrada: '',
                    potenciaFiscal: '',
                    cv: '',
                    co2: null,
                    //renting: 'NO',
                    //solicitardistintivo: '0',
                    //tipoImpositivo: '0',
                    //impuestoMatriculacion: '',
                    //importeTotalFactura: ['0', [Validators.required, Validators.min(1)]],
                  });
                }
              }
            },
            (error) => {
              console.log(error);
            }
          );
      } else if (this.datosVehiculos.value.matricula.length < 4) {
        this.datosVehiculos.setValue({
          tipo: '',
          colaborador: '',
          matricula: this.datosVehiculos.value.matricula?.toUpperCase().trim(),
          usuarioweb: '',
          bastidor: '',
          tipoVehiculo: '10',
          marca: '',
          modelo: '',
          //servicioalquesedestina: 'B00 - PART-SIN ESPECIFICAR',
          //exencion: '0',
          //tipoexencion: '0',
          //cargas: '',
          baseImponible: null,
          //nroVentas: '',
          fechaMatriculacion: null,
          cilindrada: '',
          potenciaFiscal: '',
          cv: '',
          co2: null,
          //renting: 'NO',
          //solicitardistintivo: '0',
          //tipoImpositivo: '0',
          //impuestoMatriculacion: '',
          //importeTotalFactura: ['0', [Validators.required, Validators.min(1)]],
        });
      }
    }
    get matriculaNoValido(): any {
      return (
        this.datosVehiculos.get('matricula').invalid &&
        this.datosVehiculos.get('matricula').touched
      );
    }
    
    getProvincia(): void {
      this.servicio.getProvincia().subscribe(
        async (res) => {
          console.log(res);
          this.provincias = await res;
        },
        (error) => {
          console.log(error);
        }
      );
    }
  
    getexencion(event): any {
      if (event === '1') {
        this.exencion = true;
      } else {
        if (event === '0') {
          this.exencion = false;
          this.datosVehiculos.controls.tipoexencion.setValue('');
        }
      }
      console.log(this.exencion);
    }

    getAchatarra(event): any {
      console.log("getAchatarra:");
      if (event === '1') {
        this.achatarra = true;
      } else {
        if (event === '0') {
          this.achatarra = false;
          //this.datosVehiculos.controls.achatarra.setValue('0');
        }
      }
      console.log(this.achatarra);
    }

    getMarcaModelo(): any {
      console.log("getMarcaModelo:");
      console.log(this.marcaModelo.value);
      //this.options = [];
      let resultado=this.servicio
      .getModeloIdae(this.marcaModelo.value)
      .subscribe((res) => {
        if (res !== null) {
          console.log(res);
          this.options=[];
          let arr2: string[] = new Array();
          res.forEach(item=>{this.options.push(item)}); 
        } else {
          console.log("No se encuentra el modelo")
        }
      });
    }

    onSelectionChange(event){
      //console.log('onSelectionChange called', event.option.value);
      this.marcaModelo.setValue(event.option.value.Modelo);
      this.datosAyuda.controls.marcaElectrico.setValue(event.option.value.Modelo);
      //var potenciaNumber: number = +event.option.value.Potencia_Electrica;
      this.datosAyuda.controls['potenciaKwh'].setValue(event.option.value.Potencia_Electrica);
      //var autonomiaNumber: number = +event.option.value.Autonomia_Electrica;
      this.datosAyuda.controls['autonomiaKm'].setValue(event.option.value.Autonomia_Electrica);
      if(this.concesion!="MOSTRADOR")
      {
        if(this.marcaModelo.value=="" || this.marcaModelo.value==null || this.marcaModelo.value==undefined)
          this.faltaMarcaModelo=true;
        else
          this.faltaMarcaModelo=false;
      }
      else
        this.faltaMarcaModelo=false;
    }
  
    siguiente(): void {
      this.datoTramite = {
        ...this.clienteComprador,
        ...this.datosAyuda.value,
        ...this.datosVehiculos.value,
      };
      const c = this.clasif.find(
        (res) => res.id === this.datosVehiculos.value.tipoVehiculo
      );
      this.datoTramite.tipoVehiculo = c.descripcion;
      this.datoTramite.numPedido = sessionStorage.getItem('numPedido');
      this.datoTramite.tipo = sessionStorage.getItem('tipo');
      this.datoTramite.colaborador = sessionStorage.getItem('colaborador');
      this.datoTramite.usuarioweb = sessionStorage.getItem('email');
      this.datoTramite.km = sessionStorage.getItem('km');
      this.datoTramite.paisOrigen = sessionStorage.getItem('paisOrigen');
      console.log(this.datoTramite);
      console.log("Fin siguiente");
    }

    
  
    siguiente2($event: any): void {
      this.clienteComprador = $event;
      console.log(this.datoTramite);
    }

    siguiente3($event: any): void {
      this.checkRequired();
      console.log("Datos ayuda:");
      console.log(this.datosAyuda.value);/*
      if(this.tipoAyudaSigla=="V")
      {
        console.log("V - marcaElectrico Required");
        //this.datosAyuda.get('marcaElectrico').setValidators([Validators.required]);
        //this.datosAyuda.get('marcaElectrico').updateValueAndValidity();
        this.datosAyuda.controls['marcaElectrico'].setValidators([Validators.required]);
        this.datosAyuda.controls['marcaElectrico'].updateValueAndValidity();
      }
      if(this.tipoAyudaSigla=="P")
      {
        console.log("P - marcaElectrico NOT Required");
        this.datosAyuda.get('marcaElectrico').clearValidators();
        this.datosAyuda.get('marcaElectrico').updateValueAndValidity();
      }*/

      /*this.faltaMarcaModelo=false;
      if(this.tipoAyudaSigla=="V" && (this.datosAyuda.controls.marcaElectrico.value=="" || this.datosAyuda.controls.marcaElectrico.value==undefined || this.datosAyuda.controls.marcaElectrico.value==null))
      {
        this.faltaMarcaModelo=true;
      }*/
/*
      this.datosCliente.controls.fechaNacimiento.setValue(
        this.date.transform(
          this.datosCliente.value.fechaNacimiento.value,
          'yyyy-MM-dd'
        )
      );*/
    console.log("Fecha Inicio Proyecto:"+this.datosAyuda.value.fechaInicioProyecto);

      this.datosAyuda.controls.fechaInicioProyecto.setValue(
        this.date.transform(
          this.datosAyuda.value.fechaInicioProyecto,
          'yyyy-MM-dd'
        )
      );
    
  
      this.datosAyuda.controls.fechaFinalProyecto.setValue(
        this.date.transform(
          this.datosAyuda.value.fechaFinalProyecto,
          'yyyy-MM-dd'
        )
      );
  
      this.datosAyuda.controls.fechaAchatarrado.setValue(
        this.date.transform(
          this.datosAyuda.value.fechaAchatarrado,
          'yyyy-MM-dd'
        )
      );
  
      this.datosVehiculos.controls.fechaMatriculacion.setValue(
        this.date.transform(
          this.datosVehiculos.value.fechaMatriculacion,
          'yyyy-MM-dd'
        )
      );
      this.datoTramite = {
        ...this.clienteComprador,
        ...this.datosAyuda.value,
      };
      console.log(this.datoTramite);
    }

    comprobarCamposRequeridos(): void{
      var formOK=true;
      this.faltaMarcaModelo=false;
      if(this.concesion!="MOSTRADOR")
      {
        if(this.esReinicia)
        {
          Object.keys(this.datosAyuda.controls).forEach(key =>{
            const control = this.datosAyuda.get(key);
            //this.datosAyuda.controls[key].markAsUntouched();
            console.log('Key = ' + key + ' Value = ' +   this.datosAyuda.controls[key].value);
            /*
              if(key=="vehiculoNuevo" && control.value==0)
              {
                control.setErrors({'incorrect': true});
                control.markAsTouched();
                formOK=false;
            }*/
              if(key=="expedienteConsorcio" && (control.value==undefined || control.value==""))
              {
                this.datosAyuda.controls[key].setErrors({'incorrect': true});
                this.datosAyuda.controls[key].markAsTouched();
                formOK=false;
              }
              if(key=="tipoSolicitante" && control.value==0)
              {
                this.datosAyuda.controls[key].setErrors({'incorrect': true});
                this.datosAyuda.controls[key].markAsTouched();
                formOK=false;
              }
              if(key=="achatarra" && control.value=="1")
              {
                /*if(this.datosAyuda.controls.fechaAchatarrado.value==null)
                {
                  this.datosAyuda.controls.fechaAchatarrado.setErrors({'incorrect': true});
                  this.datosAyuda.controls.fechaAchatarrado.markAsTouched();
                  formOK=false;
                }*/
                if(this.datosAyuda.controls.matriculaAchatarrado.value=="" || this.datosAyuda.controls.matriculaAchatarrado.value==undefined)
                {
                  this.datosAyuda.controls.matriculaAchatarrado.setErrors({'incorrect': true});
                  this.datosAyuda.controls.matriculaAchatarrado.markAsTouched();
                  formOK=false;
                }
                if(this.datosAyuda.controls.marcaAchatarrado.value=="" || this.datosAyuda.controls.marcaAchatarrado.value==undefined)
                {
                  this.datosAyuda.controls.marcaAchatarrado.setErrors({'incorrect': true});
                  this.datosAyuda.controls.marcaAchatarrado.markAsTouched();
                  formOK=false;
                }
                if(this.datosAyuda.controls.modeloAchatarrado.value=="" || this.datosAyuda.controls.modeloAchatarrado.value==undefined)
                {
                  this.datosAyuda.controls.modeloAchatarrado.setErrors({'incorrect': true});
                  this.datosAyuda.controls.modeloAchatarrado.markAsTouched();
                  formOK=false;
                }
              }         
          });
        }
        else
        {
          console.log("-------INICIO datosVehiculos");
              Object.keys(this.datosVehiculos.value).forEach((key) => {
                const control = this.datosVehiculos.get(key);
                console.log('Key = ' + key + ' Value = ' +   this.datosVehiculos.controls[key].value);
                if(this.concesion!="MOSTRADOR")
                {
                  if(!this.esReinicia){
                    if(key=="baseImponible" && (control.value=="" || control.value==undefined))
                      {
                        this.datosVehiculos.get('baseImponible').setValidators([Validators.required]);
                        this.datosVehiculos.get('baseImponible').updateValueAndValidity();
                        this.datosVehiculos.controls[key].setErrors({'incorrect': true});
                        this.datosVehiculos.controls[key].markAsTouched();
                        formOK=false;
                      }
                  }
                }
              });
              console.log("-------FIN datosVehiculos");
          Object.keys(this.datosAyuda.controls).forEach(key =>{
            const control = this.datosAyuda.get(key);
            //this.datosAyuda.controls[key].markAsUntouched();
            console.log('Key = ' + key + ' Value = ' +   this.datosAyuda.controls[key].value);
            /*
              if(key=="vehiculoNuevo" && control.value==0)
              {
                control.setErrors({'incorrect': true});
                control.markAsTouched();
                formOK=false;
            }*/
              if(key=="tipoAyuda" && (control.value==undefined || control.value==""))
              {
                this.datosAyuda.controls[key].setErrors({'incorrect': true});
                this.datosAyuda.controls[key].markAsTouched();
                formOK=false;
              }
              if(key=="tipoSolicitante" && control.value==0)
              {
                this.datosAyuda.controls[key].setErrors({'incorrect': true});
                this.datosAyuda.controls[key].markAsTouched();
                formOK=false;
              }
              if(key=="tipoAdquisicion" && (control.value==undefined || control.value==""))
              {
                this.datosAyuda.controls[key].setErrors({'incorrect': true});
                this.datosAyuda.controls[key].markAsTouched();
                formOK=false;
              }
              if(key=="IBAN" && (control.value==undefined || control.value==""))
              {
                this.datosAyuda.controls[key].setErrors({'incorrect': true});
                this.datosAyuda.controls[key].markAsTouched();
                formOK=false;
              }
              if(key=="potenciaKwh" && (control.value==undefined || control.value==""))
              {
                this.datosAyuda.controls[key].setErrors({'incorrect': true});
                this.datosAyuda.controls[key].markAsTouched();
                formOK=false;
              }
              if(this.tipoAyudaSigla=="V")
              {
                
                if(key=="autonomiaKm" && (control.value==undefined || control.value==""))
                {
                  this.datosAyuda.controls[key].setErrors({'incorrect': true});
                  this.datosAyuda.controls[key].markAsTouched();
                  formOK=false;
                }
                if(this.concesion!="MOSTRADOR")
                {
                  if(key=="marcaModelo" && (control.value==undefined || control.value==""))
                  {
                    console.log("DENTRO MarcaModelo");
                    this.datosAyuda.controls[key].setErrors({'incorrect': true});
                    this.datosAyuda.controls[key].markAsTouched();
                    this.faltaMarcaModelo=true;
                    console.log("VALOR faltaMarcaModelo:"+this.faltaMarcaModelo);
                    formOK=false;
                  }
                }
              }
              if(this.tipoAyudaSigla=="P")
              {
                if(key=="fechaInicioProyecto" && (control.value==undefined || control.value==""))
                {
                  this.datosAyuda.controls[key].setErrors({'incorrect': true});
                  this.datosAyuda.controls[key].markAsTouched();
                  formOK=false;
                }
                if(key=="fechaFinalProyecto" && (control.value==undefined || control.value==""))
                {
                  this.datosAyuda.controls[key].setErrors({'incorrect': true});
                  this.datosAyuda.controls[key].markAsTouched();
                  formOK=false;
                }
                if(key=="reduccionEmisiones" && control.value==0)
                {
                  this.datosAyuda.controls[key].setErrors({'incorrect': true});
                  this.datosAyuda.controls[key].markAsTouched();
                  formOK=false;
                }
                if(key=="ahorroEnergetico" && control.value==0)
                {
                  this.datosAyuda.controls[key].setErrors({'incorrect': true});
                  this.datosAyuda.controls[key].markAsTouched();
                  formOK=false;
                }
                if(key=="tipoInstalacion" && (control.value==undefined || control.value==""))
                {
                  this.datosAyuda.controls[key].setErrors({'incorrect': true});
                  this.datosAyuda.controls[key].markAsTouched();
                  formOK=false;
                }
                if(key=="numeroConectores" && (control.value==undefined || control.value==""))
                {
                  this.datosAyuda.controls[key].setErrors({'incorrect': true});
                  this.datosAyuda.controls[key].markAsTouched();
                  this.datosAyuda.controls[key].markAsDirty();
                  formOK=false;
                }
                if(key=="tipoConector" && (control.value==undefined || control.value==""))
                {
                  this.datosAyuda.controls[key].setErrors({'incorrect': true});
                  this.datosAyuda.controls[key].markAsTouched();
                  formOK=false;
                }
                if(key=="inversionTotal" && control.value==0)
                {
                  this.datosAyuda.controls[key].setErrors({'incorrect': true});
                  this.datosAyuda.controls[key].markAsTouched();
                  formOK=false;
                }
                if(key=="marcaModeloCargador" && (control.value==undefined || control.value==""))
                {
                  this.datosAyuda.controls[key].setErrors({'incorrect': true});
                  this.datosAyuda.controls[key].markAsTouched();
                  formOK=false;
                }
              }
              if(key=="achatarra" && control.value=="1")
              {
                /*if(this.datosAyuda.controls.fechaAchatarrado.value==null)
                {
                  this.datosAyuda.controls.fechaAchatarrado.setErrors({'incorrect': true});
                  this.datosAyuda.controls.fechaAchatarrado.markAsTouched();
                  formOK=false;
                }*/
                if(this.datosAyuda.controls.matriculaAchatarrado.value=="" || this.datosAyuda.controls.matriculaAchatarrado.value==undefined)
                {
                  this.datosAyuda.controls.matriculaAchatarrado.setErrors({'incorrect': true});
                  this.datosAyuda.controls.matriculaAchatarrado.markAsTouched();
                  formOK=false;
                }
                if(this.datosAyuda.controls.marcaAchatarrado.value=="" || this.datosAyuda.controls.marcaAchatarrado.value==undefined)
                {
                  this.datosAyuda.controls.marcaAchatarrado.setErrors({'incorrect': true});
                  this.datosAyuda.controls.marcaAchatarrado.markAsTouched();
                  formOK=false;
                }
                if(this.datosAyuda.controls.modeloAchatarrado.value=="" || this.datosAyuda.controls.modeloAchatarrado.value==undefined)
                {
                  this.datosAyuda.controls.modeloAchatarrado.setErrors({'incorrect': true});
                  this.datosAyuda.controls.modeloAchatarrado.markAsTouched();
                  formOK=false;
                }
              }         
          });
        }
      }
      else
      {
        if(this.esReinicia)
        {

        }
        else
        {

        }
      }
      this.requeridosOK=formOK;
    }
  
    getSolicitud(): void {
      this.servicio.getOneSolicitud(this.solicitud).subscribe(
        (res) => {
          this.setDatos(res);
        },
        (error) => {
          console.log(error);
        }
      );
    }
  
    getDatosEITV(): void {
      if (
        this.datosVehiculos.get('bastidor').value == '' ||
        this.datosVehiculos.get('bastidor').invalid
      ) {
        Swal.fire(
          '',
          'Se necesita un bastidor válido para recuperar los datos del vehículo desde la DGT',
          'warning'
        );
      } else {
        this.spinnerEITV = true;
        this.servicio
          .getEITV(this.datosVehiculos.get('bastidor').value)
          .subscribe({
            next: (value) => {
              console.log(value.content);
              if (value.error == 'ERROR')
                Swal.fire(
                  '',
                  'Error recuperando los datos: ' +
                    value.content +
                    '. Por favor rellene manualmente los datos.',
                  'warning'
                );
              else {
                Swal.fire('', 'Datos EITV recuperados con éxito', 'success');
                this.datosVehiculos.controls.marca.setValue(
                  value.content.datos.MARCA
                );
                this.datosVehiculos.controls.modelo.setValue(
                  value.content.datos.MODELO
                );
                this.datosVehiculos.controls.co2.setValue(
                  (parseInt(value.content.datos.EMISION_CO2) / 1000).toFixed(0)
                );
                this.datosVehiculos.controls.tipoVehiculo.setValue(
                  value.content.datos.CLASIFICACION_VEHICULO.slice(0, 2)
                );
                this.datosVehiculos.controls.cv.setValue(
                  (parseInt(value.content.datos.POTENCIA_NETA) / 1000).toString()
                );
                this.datosVehiculos.controls.potenciaFiscal.setValue(
                  (parseInt(value.content.datos.POTENCIA_FISCAL) / 100).toString()
                );
                this.datosVehiculos.controls.cilindrada.setValue(
                  parseInt(value.content.datos.CILINDRADA).toFixed(0)
                );
              }
            },
            error: (err) => {
              console.log(err);
              Swal.fire(
                '',
                'Imposible conectar con la DGT, por favor compruebe el bastidor y si es correcto rellene manualmente los datos del vehículo',
                'warning'
              );
            },
            complete: () => {
              this.spinnerEITV = false;
              this.recuperadoEITV = true;
            },
          });
      }
    }
  
    setDatos(datos): void {
      console.log(datos.tipoVehiculo);
      if (datos.tipoVehiculo !== null) {
        this.datosVehiculos.controls.tipoVehiculo.setValue(
          datos.tipoVehiculo?.trim().slice(0, 2)
        );
      } else {
        this.datosVehiculos.controls.tipoVehiculo.setValue(
          datos.tipoVehiculo?.trim() === '' ? '10' : datos.tipoVehiculo?.trim()
        );
      }/*
      if (
        datos.servicioalquesedestina === null ||
        datos.servicioalquesedestina === 'null' ||
        datos.servicioalquesedestina === 'NULL' ||
        // tslint:disable-next-line:max-line-length
        datos.servicioalquesedestina === '' ||
        datos.servicioalquesedestina === 'undefined' ||
        datos.servicioalquesedestina === 'UNDEFINED'
      ) {
        this.datosVehiculos.controls.servicioalquesedestina.setValue(
          'B00 - PART-SIN ESPECIFICAR'
        );
      } else {
        this.datosVehiculos.controls.servicioalquesedestina.setValue(
          datos.servicioalquesedestina
        );
      }*/
      //const exencion = this.getRespuesta(datos.exencion);
      //this.datosVehiculos.controls.exencion.setValue(exencion);
      //this.datosVehiculos.controls.tipoexencion.setValue(datos.tipoexencion);
      //const renting = this.getRespuesta(datos.renting);
      //this.datosVehiculos.controls.renting.setValue(renting);
      //const solicitardistintivo = this.getRespuesta(datos.solicitardistintivo);
      //this.datosVehiculos.controls.solicitardistintivo.setValue(
      //  solicitardistintivo
      //);
      this.datosVehiculos.controls.bastidor.setValue(datos.bastidor);
      this.datosVehiculos.controls.baseImponible.setValue(datos.baseImponible);
      this.datosVehiculos.controls.cv.setValue(datos.hp);
      //this.datosVehiculos.controls.tipoImpositivo.setValue(datos.tipoImpositivo);
      this.datosVehiculos.controls.co2.setValue(datos.co2);
      this.datosVehiculos.controls.potenciaFiscal.setValue(datos.potencianetaitv);
      this.datosVehiculos.controls.cilindrada.setValue(datos.cilindrada);
      this.datosVehiculos.controls.fechaMatriculacion.setValue(datos.fechaMatriculacion);
      this.datosVehiculos.controls.marca.setValue(datos.marca);
      this.datosVehiculos.controls.modelo.setValue(datos.modelo);
      this.datosVehiculos.controls.tipoVehiculo.setValue(datos.clasificacion.slice(0, 2));
      //this.datosVehiculos.controls.impuestoMatriculacion.setValue(
      //  datos.impuestoMatriculacion
      //);
      //this.datosVehiculos.controls.importeTotalFactura.setValue(
      //  datos.importeTotalFactura
      //);
      //sessionStorage.setItem('tipo', datos.tipo);
    }
  
    getRespuesta(condition): string {
      let v = '';
      switch (condition) {
        case false:
          v = '0';
          break;
        case true:
          v = '1';
          break;
      }
      return v;
    }
  
    calcularImpuesto(): void {
      let idProv = 0;
      this.provincias.map((p) => {
        if (p.nomprov.includes(this.clienteComprador.provincia)) {
          idProv = p.idprov;
        }
      });
      if (this.datosVehiculos.value.co2) {
        const impuesto = this.servicio.cacularImpositivo(
          this.datosVehiculos.value.tipoVehiculo,
          idProv,
          this.datosVehiculos.value.cv,
          this.datosVehiculos.value.co2
        );
        this.datosVehiculos.controls.tipoImpositivo.setValue(impuesto);
      }
      if (this.datosVehiculos.value.baseImponible) {
        this.impuestoMtriculacion();
      }
    }
  
    clasificacion(): void {
      switch (this.datosVehiculos.value.tipoVehiculo) {
        case '03':
        case '04':
          this.ocultar = false;
          this.datosVehiculos.get('cv').setValidators([Validators.required]);
          this.datosVehiculos.get('cv').updateValueAndValidity();
          this.calcularImpuesto();
          break;
        default:
          this.ocultar = true;
          this.datosVehiculos.controls.cv.setValue('');
          this.datosVehiculos.get('cv').clearValidators();
          this.datosVehiculos.get('cv').updateValueAndValidity();
          this.calcularImpuesto();
          break;
      }
    }

    mostrarCampos(): void {
      console.log("mostrarCampos:");
      console.log(this.datosAyuda.value.tipoSolicitante);
      switch (this.datosAyuda.value.tipoSolicitante) {
        case 'PROFESIONAL AUTONOMO':
          this.mostrarCif = true;
          this.mostrarIAE = true;
          this.mostrarMinimis =false;

          //this.datosAyuda.get('cif').setValidators([Validators.required]);
          //this.datosAyuda.get('cif').updateValueAndValidity();

          //this.datosAyuda.get('IAE').setValidators([Validators.required]);
          //this.datosAyuda.get('IAE').updateValueAndValidity();
          break;
          case 'SOCIEDAD ANONIMA':
          case 'SOCIEDAD LIMITADA':
          case 'COMUNIDAD DE BIENES':
          case 'COMUNIDAD DE PROPIETARIOS':
          this.mostrarCif = true;
          this.mostrarIAE = true;
          this.mostrarMinimis =true;

          //this.datosAyuda.get('cif').setValidators([Validators.required]);
          //this.datosAyuda.get('cif').updateValueAndValidity();

          //this.datosAyuda.get('IAE').setValidators([Validators.required]);
          //this.datosAyuda.get('IAE').updateValueAndValidity();
          break;
        default:
          this.mostrarCif = false;
          this.mostrarIAE = false;
          this.mostrarMinimis =false;

          this.datosAyuda.get('cif').clearValidators();
          this.datosAyuda.get('cif').updateValueAndValidity();

          this.datosAyuda.get('IAE').clearValidators();
          this.datosAyuda.get('IAE').updateValueAndValidity();

          this.datosAyuda.get('minimis').clearValidators();
          this.datosAyuda.get('minimis').updateValueAndValidity();
          break;
      }
    }
  
    impuestoMtriculacion(): void {
      const respuesta = this.servicio.calcularImpuesto(
        parseFloat(this.datosVehiculos.value.baseImponible),
        parseFloat(this.datosVehiculos.value.tipoImpositivo)
      );
      this.datosVehiculos.controls.impuestoMatriculacion.setValue(respuesta);
    }
  
    clasificaciones(): void {
      this.clasif = [
        { id: '03', descripcion: '03xx – CICLOMOTOR' },
        { id: '04', descripcion: '04xx – MOTOCICLETA' },
        { id: '06', descripcion: '06xx – AUTOMOVIL DE TRES RUEDAS' },
        { id: '10', descripcion: '10xx – TURISMO' },
        { id: '17', descripcion: '17xx – PICK UP' },
        { id: '20', descripcion: '20xx – CAMION MMA <=3.500 kg' },
        { id: '21', descripcion: '21xx – CAMION 3.500 kg. < MMA <= 12.500 kg' },
        { id: '22', descripcion: '22xx – CAMION MMA > 12.000 kg' },
        { id: '24', descripcion: '24xx – FURGON/FURGONETA MMA <= 3.500 kg' },
        { id: '31', descripcion: '31xx – VEHICULO MIXTO ADAPTABLE' },
        { id: '32', descripcion: '32xx – AUTO-CARAVANA MMA <= 3.500 kg' },
        { id: '33', descripcion: '33xx – AUTO-CARAVANA MMA > 3.500 kg' },
        { id: '66', descripcion: '66xx – QUAD ATV' },
      ];
    }

    setTipoAyuda()
    {
      console.log("Tipo de ayuda:"+this.datosAyuda.controls.tipoAyuda.value);
      if(this.datosAyuda.controls.tipoAyuda.value=="PLAN MOVES III 2025 - ADQUISICION VEHICULO ELECTRICO")
      {
        this.tipoAyudaSigla="V";
        if(this.concesion!="MOSTRADOR")
          this.faltaMarcaModelo=true;
        else
          this.faltaMarcaModelo=false;
      }
      else
      {
        this.tipoAyudaSigla="P";
        this.faltaMarcaModelo=false;
      }
      console.log("Tipo de ayuda sigla:"+this.tipoAyudaSigla);
    }

    checkRequired()
    {
      console.log("-------INICIO checkRequired");
      console.log("-------INICIO datosVehiculos");
      var formOK=true;
            Object.keys(this.datosVehiculos.value).forEach((key) => {
              const control = this.datosVehiculos.get(key);
              console.log('Key = ' + key + ' Value = ' +   this.datosVehiculos.controls[key].value);
              if(this.concesion!="MOSTRADOR")
              {
                if(!this.esReinicia){
                  if(key=="baseImponible" && (control.value=="" || control.value==undefined || control.value=='0.00'))
                    {
                      this.datosVehiculos.get('baseImponible').setValidators([Validators.required]);
                      this.datosVehiculos.get('baseImponible').updateValueAndValidity();
                      this.datosVehiculos.controls[key].setErrors({'incorrect': true});
                      this.datosVehiculos.controls[key].markAsTouched();
                      formOK=false;
                    }
                }
              }
            });
            this.requeridosOK=formOK;
            console.log("-------FIN datosVehiculos");
    }
}
